export class SuggestedPlayerInfo {
    constructor(json?: any) {
        this.homeTown = json && json.home_town || null;
        this.height = json && json.height || null;
        this.weight = json && json.weight || null;
        this.shoots = json && json.shoots || null;
        this.catches = json && json.catches || null;
        this.position = json && json.position || null;
        this.positionShort = json && json.position_short || null;
    }

    homeTown: string;
    height: string;
    weight: string;
    shoots: string;
    catches: string;
    position: string;
    positionShort: string;
}